module.exports = __webpack_public_path__ + "static/media/02.bc47a9fa.jpg";